export default __webpack_public_path__ + "static/media/fox.578fce8c.png";